module.exports = __webpack_public_path__ + "static/media/profile-terry-pitts.84b1f579.jpg";